/* eslint-disable react/no-unknown-property */
import { Canvas } from '@react-three/fiber';
import { Environment, useContextBridge } from '@react-three/drei';
import Style from './style.module.scss';
import { ControlContext } from 'provider/ControlProvider';
import NavigationButtonList from 'components/NavigationButtonList';
import Cities from 'componentsForThree/Cities';
import Controls from 'componentsForThree/Controls';

export default function Configurator() {
  const ContextBridge = useContextBridge(ControlContext);
  return (
    <div className={Style.wrapper}>
      <Canvas
        id='scene'
        dpr={[1, 2]}
        performance={{ min: 0.1 }}
        gl={{ antialias: false }}
        camera={{ position: [0, 4500, 0], near: 0.01 }}
        className={'bg-zinc-700'}
      >
        <Environment preset='apartment' />
        <ContextBridge>
          <Cities />
          <Controls />
        </ContextBridge>
      </Canvas>
      <NavigationButtonList />
      <div className='absolute top-20 right-2 text-white'>
        <h5>Mail: valcano103@gmail.com</h5>
        <h5>Discord: Volcano#2146</h5>
      </div>
    </div>
  );
}
